/**
 * Authentication API service
 */

import { apiClient } from './client';
import type { LoginRequest, LoginResponse, VerifySlugResponse } from '@/types/api';

const STORAGE_KEY = 'user-slug';

/**
 * POST /api/auth/login
 * Passwordless login — stores slug in localStorage
 */
export async function login(data: LoginRequest): Promise<LoginResponse> {
  const response = await apiClient.post<LoginResponse>('/auth/login', data);
  localStorage.setItem(STORAGE_KEY, response.data.user.slug);
  return response.data;
}

/**
 * GET /api/auth/verify/:slug
 * Verify stored slug from localStorage
 */
export async function getMe(): Promise<VerifySlugResponse> {
  const slug = localStorage.getItem(STORAGE_KEY);
  if (!slug) {
    return { valid: false };
  }
  const response = await apiClient.get<VerifySlugResponse>(`/auth/verify/${slug}`);
  return response.data;
}

/**
 * Logout — clear localStorage
 */
export async function logout(): Promise<void> {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Get stored slug (for x-user-slug header)
 */
export function getStoredSlug(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}
